import * as React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';

export default function AlertDialog({hypeInfo, hypeOpen}) {
  return (
    <div>
      <Dialog
        open={hypeInfo}
        onClose={hypeOpen}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          {"Interactions fuel the Hype system"}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
          Based on an algorithm that analyzes likes, retweets, comments, and followers from the past week.
          </DialogContentText>
        </DialogContent>
        {/* <DialogActions>
          <Button onClick={hypeOpen}>Disagree</Button>
          <Button onClick={hypeOpen} autoFocus>
            Agree
          </Button>
        </DialogActions> */}
      </Dialog>
    </div>
  );
}
